class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

/**
 * Products header menu
 */
class HeaderProductsMenu extends HTMLElement {
  /**
   * 标签选择器
   */
  selectors = {
    megaAsideItem: ".products-menu__aside-item",
    megaSectionTab: ".products-menu__product-tab",
    megaProductSectionsWrapper: ".products-menu__content-inner>section",
    megaProductSection: ".products-menu__product-section",
    megaProductList: ".products-menu__product-list",
  };

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle = this.querySelector("details");

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('mouseenter', () => {
        this.mainDetailsToggle.setAttribute('open', '');
        this.mainDetailsToggle.classList.add('header-menu--open');
      });
      this.mainDetailsToggle.addEventListener('mouseleave', () => {
        this.mainDetailsToggle.classList.remove('header-menu--open');
        this.closeAnimation();
      });
      this.mainDetailsToggle.addEventListener('click', (event) => {
        if (event.target == this.mainDetailsToggle)
          event.preventDefault();
      });
    }

    this.elements = {
      megaProductSectionsWrapper: this.querySelector(this.selectors.megaProductSectionsWrapper),
      megaProductSectionList: this.querySelectorAll(this.selectors.megaProductSection),
    }

    this.initProductsMega();
  }

  initProductsMega() {
    const selectors = this.selectors;
    $(this).find(selectors.megaAsideItem).on("mouseenter", (e) => {
      const currentEl = e.currentTarget;
      // 移除 aside 已激活状态
      this.querySelector(selectors.megaAsideItem + ".active")?.classList.remove("active");
      currentEl.classList.add("active");
      // 显示对应的 section，隐藏其他
      const index = currentEl.getAttribute("data-index");
      this.querySelector(`${selectors.megaProductSection}.active`)?.classList.remove("active");
      this.querySelector(`${selectors.megaProductSection}[data-index="${index}"]`).classList.add("active");
    });
    $(this).find(selectors.megaSectionTab).on("mouseenter", (e) => {
      /** @type {HTMLElement} */
      const currentEl = e.currentTarget;
      const section = currentEl.closest(selectors.megaProductSection);
      // 移除 tab 已激活状态
      section.querySelector(`${selectors.megaSectionTab}.active`)?.classList.remove("active");
      currentEl.classList.add("active");
      // 显示对应的 product list，隐藏其他
      const index = currentEl.getAttribute("data-index");
      section.querySelector(`${selectors.megaProductList}.active`)?.classList.remove("active");
      section.querySelector(`${selectors.megaProductList}[data-index="${index}"]`).classList.add("active");
    });

    this.resizeObserver = new ResizeObserver(this.resize.bind(this));
    this.resizeObserver.observe(document.body);
  }

  resize() {
    let height = 0;
    for (const section of this.elements.megaProductSectionList) {
      height = Math.max(height, section.firstElementChild.clientHeight);
    }
    this.elements.megaProductSectionsWrapper.style.height = height + 'px';
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  closeAnimation() {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      // 200 为过渡动画时间
      if (elapsedTime < 200) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        if (!this.mainDetailsToggle.classList.contains("header-menu--open"))
          this.mainDetailsToggle.removeAttribute('open');
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('header-products-menu', HeaderProductsMenu);